import { gql } from '@apollo/client';

export const TitleFragment = gql`
  fragment Title on Title {
    code
    displayName
    language
  }
`;
